module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/82fe1cef63c1d080dd48d7625f6b8b5a.png";